<template>
    <div class="financial_management padding-20 bgc box-shadow">
        <el-tabs v-model="activeName" @tab-click="handleClick(activeName)">
            <el-tab-pane label="全部记录" name="first">
                <AllBills :data="data"></AllBills>
            </el-tab-pane>
            <el-tab-pane label="支出记录" name="second">
                <SpendingRecords :data="data"></SpendingRecords>
            </el-tab-pane>
            <el-tab-pane label="收入记录" name="third">
                <IncomeRecords :data="data"></IncomeRecords>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import {findBillToList} from 'api/materialMgtApi'
import AllBills from 'views/orderMgt/balance/subTab/AllBills'
import SpendingRecords from 'views/orderMgt/balance/subTab/SpendingRecords'
import IncomeRecords from 'views/orderMgt/balance/subTab/IncomeRecords'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'allrecord',
    data() {
        return {
            activeName: 'first',
            activeName2: 'first',
            showdDetails: false,
            data: {}
        }
    },
    mounted() {
        this.getFindBillToList()
    },
    methods: {
        handleClick(tabName) {
            if (tabName === this.activeName2) {
                
            } else {
                this.activeName2 = tabName
                if (tabName === 'first') {
                    this.getFindBillToList()
                } else if (tabName === 'second') {
                    this.getSpendingRecords()
                } else if (tabName === 'third') {
                    this.getIncomeRecords()
                }
            }
        },
        // 获取账单列表全部记录
        getFindBillToList() {
            this.setLoading(true)
            var params = {
                moneydirect: ''
            }
            findBillToList({
                data: Object.assign({}, params, this.page),
                success: data => {
                    this.data = data
                    this.setLoading(false)
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 获取收入记录
        getIncomeRecords() {
            this.setLoading(true)
            findBillToList({
                data: {
                    moneydirect: 1, // 1转入 2转出'
                    page: 1,
                    pageSize: 10
                },
                success: data => {
                    this.data = data
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        // 获取支出记录
        getSpendingRecords() {
            this.setLoading(true)
            findBillToList({
                data: {
                    moneydirect: 2, // 1转入 2转出'
                    page: 1,
                    pageSize: 10
                },
                success: data => {
                    this.data = data
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'page',
            'user'
        ])
    },
    components: {
        AllBills,
        SpendingRecords,
        IncomeRecords
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/base";
.financial_management {
    padding-bottom: 50px;
}
</style>